angular.
module("dx.webapp.library").
directive("dxGradingMatrixLibrary", function gradingMatrixLibraryDirective() {
	"use strict";

	return {
		restrict: "E",
		templateUrl: "tmpl/library/grading-matrix-library-directive.html",
		replace: true,
		controller: "DxGradingMatrixLibraryController",
	};
});
